import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";
import GlassLoader from "../components/ui/GlassLoader";

function ContactsPage() {
  const navigate = useNavigate();
  const username = localStorage.getItem("user");

  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadContacts = async () => {
      const ref = doc(db, "users", username);
      const snap = await getDoc(ref);

      if (!snap.exists()) {
        setLoading(false);
        return;
      }

      const data = snap.data();
      const contactUsernames = data.contacts || [];

      const usersData = await Promise.all(
        contactUsernames.map(async (name) => {
          const ref = doc(db, "users", name);
          const snap = await getDoc(ref);
          return snap.exists() ? snap.data() : null;
        })
      );

      setContacts(usersData.filter(Boolean));
      setLoading(false);
    };

    loadContacts();
  }, [username]);

  // 🧊 skeleton
  if (loading) return <GlassLoader />;

  return (
    <div style={styles.container}>
      <div style={styles.content}>

        {/* 🔙 */}
        <button
          onClick={() => navigate("/")}
          style={styles.glassBtn}
        >
          ← Назад
        </button>

        <h2 style={{ textAlign: "center" }}>Контакты</h2>

        {contacts.length === 0 && (
          <p style={{ color: "#aaa", textAlign: "center" }}>
            У тебя пока нет контактов
          </p>
        )}

        {contacts.map((c, i) => (
          <div
            key={i}
            style={styles.contact}
            onClick={() => navigate(`/user/${c.username}`)} // 👈 профиль
          >
            <img
              src={c.avatar || "https://via.placeholder.com/50"}
              style={styles.avatar}
            />

            <div style={{ flex: 1 }}>
              <div style={styles.name}>{c.username}</div>
              <div style={styles.status}>
                {c.status || "Без статуса"}
              </div>
            </div>

            {/* 💬 написать */}
            <button
              style={styles.messageBtn}
              onClick={(e) => {
                e.stopPropagation(); // ❗ не открывать профиль
                navigate(`/chat/${c.username}`);
              }}
            >
              Написать
            </button>
          </div>
        ))}

      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: "100vh",
    background: "#1e1e1e",
    display: "flex",
    justifyContent: "center",
    color: "#fff"
  },

  content: {
    width: "100%",
    maxWidth: 700,
    padding: 15,
    display: "flex",
    flexDirection: "column",
    gap: 12
  },

  contact: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    padding: 12,
    borderRadius: 14,

    background: "rgba(255,255,255,0.05)",
    border: "1px solid rgba(255,255,255,0.1)",
    backdropFilter: "blur(10px)",

    cursor: "pointer",
    transition: "all 0.2s ease"
  },

  avatar: {
    width: 50,
    height: 50,
    borderRadius: "50%"
  },

  name: {
    fontWeight: "bold"
  },

  status: {
    fontSize: 12,
    color: "#aaa"
  },

  messageBtn: {
    padding: "10px 16px",
    borderRadius: 10,

    background: "rgba(255,255,255,0.15)",
    border: "1px solid rgba(255,255,255,0.25)",

    color: "#fff",
    fontSize: 14,
    cursor: "pointer",

    transition: "0.2s"
  },

  glassBtn: {
    alignSelf: "flex-start",
    padding: "8px 12px",
    borderRadius: 12,
    border: "1px solid rgba(255,255,255,0.15)",
    background: "rgba(255,255,255,0.08)",
    color: "#fff",
    cursor: "pointer"
  },

};

export default ContactsPage;